import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'atom-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent {
  @Input() progressValue:number = 0;
  @Input() tooltipText?: string;

  constructor(private translateService: TranslateService) {}

  getTooltipTranslation(): string {
    if (!this.tooltipText) return '';

    // Separar el texto antes de los dos puntos y los números
    const [textPart, numberPart] = this.tooltipText.split(':');

    if (!textPart) return this.tooltipText;

    // Traducir solo la parte del texto
    const translatedText = this.translateService.instant('TOOLTIPS.' + textPart.trim());

    // Si no existe traducción, devolver el texto tal y como está
    const finalText = translatedText !== 'TOOLTIPS.' + textPart.trim() ? translatedText : textPart.trim();

    // Reconstruir el string con la traducción y los números originales
    return numberPart ? `${finalText}: ${numberPart}` : finalText;
  }
}
